import React from 'react';
import { Link } from 'react-router-dom'

const Navigation = () => (
  <div className="mdl-navigation">
    <Link to='/dashboard' className="mdl-navigation__link">Dashboard</Link>
    <Link to='/profile' className="mdl-navigation__link">Profile</Link>
  </div>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/components/navigation.js